import { React, useEffect, useState } from "react";
import EquipmentService from "../../../services/equipment";
import MaintenanceService from "../../../services/maintenance";
import PaginationMain from "../Main/PaginationMain";
import { CODES } from "../../../utils/httpCodes";
import { simpleAlerts } from "../../../utils/alerts";
import EquipmentMaintenanceHistory from "./EquipmentMaintenanceHistory";
import { Modal } from "@mui/material";

const columns = [
  { id: "id_equipo", label: "#", width: 30, align: "center" },
  { id: "fechaAdq", label: "Fecha", width: 50, align: "left" },
  { id: "nombre", label: "Nombre", width: 90, align: "left" },
  { id: "marca", label: "Marca", width: 90, align: "left" },
  { id: "modelo", label: "Modelo", width: 100, align: "left" },
  { id: "nroSerie", label: "Serie", width: 100, align: "left" },
  { id: "imei", label: "IMEI", width: 100, align: "left" },
  { id: "sel", label: "Seleccionar", width: 50, align: "center" },
];
const BodyMaintenance = ({
handleOpenLoad,handleCloseLoad,
setTitleLoad,
data,open,
resultSearch,
selectedItems,setSelectedItems,
selectAll,setSelectAll,
totalPages,page,setPage,
handleOpen,handleClose,
setMaintenanceEquip,maintenanceEquip,
tiposMantenimiento,setTiposMantenimiento
}) => {

  const url = window.location.pathname;
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [newRows, setNewRows] = useState([]);
  

  useEffect(() => {
    // Manejar la selección de todos cuando cambia el estado de "selectAll"
    if (selectAll) {
      const allItems = resultSearch.map((row) => ({
        id_equipo: row.id_equipo,
        codigoBarras: row.codigoBarras[0].codigoBarras,
        rucEmpresa: row.rucEmpresa,
        // Agrega más campos aquí según tu estructura
      }));
      setSelectedItems(allItems);
    } else {
      setSelectedItems([]);
    }
  }, [selectAll, resultSearch]);

  const handleHeaderCheckboxChange = () => {
    setSelectAll(!selectAll);
    const allItems = resultSearch.map((row) => ({
      id_equipo: row.id_equipo,
      codigoBarras: row?.codigoBarras[0]?.codigoBarras,
      rucEmpresa: row.rucEmpresa,
      // Agrega más campos aquí según tu estructura
    }));

    if (!selectAll) {
      // Si selectAll es false, significa que estamos activando la selección de todos
      setSelectedItems(allItems);
    } else {
      // Si selectAll es true, significa que estamos desactivando la selección de todos
      setSelectedItems([]);
    }
  };

  const handleCheckboxChange = (row) => {
    const updatedSelectedItems = [...selectedItems];

    const itemIndex = updatedSelectedItems.findIndex(
      (item) => item.id_equipo === row.id_equipo,
    );

    if (itemIndex === -1) {
      // Si no está seleccionado, agregarlo
      updatedSelectedItems.push({
        id_equipo: row.id_equipo,
        codigoBarras: row.codigoBarras[0].codigoBarras,
        rucEmpresa: row.rucEmpresa,
        // Agrega más campos aquí según tu estructura
      });
    } else {
      // Si ya está seleccionado, quitarlo
      updatedSelectedItems.splice(itemIndex, 1);
    }

    setSelectedItems(updatedSelectedItems);
  };
  const getEquipmentMaintenance = async (info) => {
    try {
      handleOpenLoad();
      setTitleLoad("Buscando información ...");
      setSelectedEquipment(info);
      const result = await MaintenanceService.getEquipmentMaintenance(
        url,
        info.id_equipo,
      );
      if (result.status === CODES.SUCCESS_200) {
        setMaintenanceEquip(result.data);
        handleOpen();
      }
      return [];
    } catch (error) {
      console.log(`Error en getEquipmentMaintenance: ${error}`);
    } finally {
      handleCloseLoad();
      setTitleLoad(null);
    }
  };

  const addMaintenanceRow = () => {
   const newRow = {
     id: Date.now(),
     fecha: "",
     tipo: "",
     tecnico: "",
     isNew: true,
     preguntas: [],
     respuestas: {},
   };


    setNewRows([...newRows, newRow]);
  };

  const updateNewRow = (id, field, value) => {
    setNewRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row)),
    );
  };

  const handleCloseModal = () => {
  setNewRows([]);
  setSelectedEquipment(null);
  handleClose();
};

  return (
    <>
      <div className="body-table table-responsive">
        <div className="container">
          <div className="body-table-wrapper mt-3">
            <table className="table table-bordered table-hover table-sm">
              <thead
                className="table-dark sticky-top"
                style={{ fontSize: "10px" }}
              >
                <tr>
                  {columns.map((col) => (
                    <th
                      scope="col"
                      key={col.id}
                      style={{
                        textAlign: col.align,
                        width: `${col.width}px`,
                        maxWidth: `${col.width}px`,
                      }}
                    >
                      {col.id === "sel" ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <label
                            htmlFor={`checkbox-rect-header`}
                            className="ml-1"
                          >
                            Sel
                          </label>
                          <input
                            style={{ marginLeft: "5px" }}
                            type="checkbox"
                            name="check"
                            id={`checkbox-rect-header`}
                            className={"checkbox-rect-header"}
                            checked={selectAll}
                            onChange={handleHeaderCheckboxChange}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ marginRight: "auto" }}>{col.label}</div>
                        </div>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody style={{ fontSize: "10px" }}>
                {data?.map((row, idx) => {
                  return (
                    <tr
                      key={idx}
                      style={{ cursor: "pointer" }}
                      onClick={() => getEquipmentMaintenance(row)}
                    >
                      {columns.map((col) => {
                        const value = row[col.id];

                        return (
                          <td
                            key={col.id}
                            style={{
                              textAlign: col.align,
                              width: `${col.width}px`,
                              maxWidth: `${col.width}px`,
                            }}
                          >
                            {col.id === "sel" ? (
                              <div
                                className="checkbox-custom"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedItems.some(
                                    (item) => item.id_equipo === row.id_equipo,
                                  )}
                                  onChange={() => handleCheckboxChange(row)}
                                />
                                <label htmlFor={`checkbox-rect`}></label>
                              </div>
                            ) : (
                              value
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <PaginationMain
          size={"small"}
          totalPages={totalPages}
          page={page}
          setPage={setPage}
        />
      </div>
      <Modal open={open} onClose={handleCloseModal}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: '65%',
            height:'65%',
            backgroundColor: "#fff",
            borderRadius: "4px",
            padding: "20px",
          }}
        >
          {selectedEquipment && (
            <div
              className="mb-2 p-2 border rounded bg-light"
              style={{ color: "black" }}
            >
              <strong>Equipo: </strong> {selectedEquipment.nombre} <br />
              <strong>Marca : </strong> {selectedEquipment.marca} <br />
              <strong>Modelo: </strong> {selectedEquipment.modelo} <br />
              <strong>Serie : </strong> {selectedEquipment.nroSerie}
            </div>
          )}
          <EquipmentMaintenanceHistory
            data={maintenanceEquip?.data}
            newRows={newRows}
            setNewRows={setNewRows}
            addMaintenanceRow={addMaintenanceRow}
            updateNewRow={updateNewRow}
            tiposMantenimiento={tiposMantenimiento}
            setTiposMantenimiento={setTiposMantenimiento}
            handleOpenLoad={handleOpenLoad}
            handleCloseLoad={handleCloseLoad}
            url={url}
            setTitleLoad={setTitleLoad}
            selectedEquipment={selectedEquipment}
            getEquipmentMaintenance={getEquipmentMaintenance}
          />

          <div className="text-end mt-3">
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => {
                setNewRows([]);
                handleClose();
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BodyMaintenance;
